// extracted by mini-css-extract-plugin
module.exports = {"layerContainer":"NoticeLayer_layerContainer__ehae5","defaultUi":"NoticeLayer_defaultUi__eaL7r"};